import { Link, LinkTypeMap } from "@mui/material";
import { NavLink, NavLinkProps } from "react-router-dom";

type Props = LinkTypeMap["props"] & NavLinkProps;

export const MuiNavLink: React.FC<Props> = ({ children, ...props }) => {
  return (
    <Link component={NavLink} color="primary.dark" {...props}>
      {children}
    </Link>
  );
};
